<template>
  <b-modal v-model="show" size="lg" centered header-bg-variant="primary" hide-footer title="Upload Image" @show="setData" @hide="cancelAddModal()">
    <div class="d-block uploadCdnImageWrapper">
      <b-row>
        <b-col sm="12" v-if="show">
          <b-row>
            <b-col sm="5">
              <label>Please Select Folder Destination to Upload</label>
              <treeselect :options="filterFolderList" v-model="activefolder" :normalizer="normalizer" :max-height="1000" isDefaultExpanded :default-expand-level="1" class="folderWrapper" always-open >
                <label slot="option-label" slot-scope="{ node, shouldShowCount, count, labelClassName }" :class="labelClassName">
                  <i class='fa fa-folder-o mr-2'></i> {{ node.label }}
                </label>
              </treeselect>
            </b-col>
            <b-col sm="7">
              <p-image v-model="form.cdnImage" label="Upload Image" :name="`cdnImage`" :handler="$v" :formData="form" />
              <label v-if="fileSelectError" class="uploadImageErrorCDN">Please Select Folder before uploading</label>
            </b-col>
            <b-col sm="12" class="mt-2 text-right">
              <b-button variant="success" @click="addImage()">Upload</b-button>
              <b-button variant="outline-danger" @click="cancelAddModal()">Cancel</b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>
  </b-modal>
</template>

<script>

import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import { Events } from '../../events.js'
import VueNotifications from 'vue-notifications'
import { required } from 'vuelidate/lib/validators'
import { PImage } from '../../components'

export default {
  props: {
    showAddModal: {
      type: Boolean,
      default: false
    },
    parentIdx: {
      type: [ Number, String ],
      default: ''
    },
    folderList: {
      type: Array,
      default: function () { return [] }
    }
  },
  data: () => {
    return {
      activefolder: '',
      fileSelectError: false,
      form: {
        cdnImage: '',
        errorMessages: {
          cdnImage: {
            required: 'CDN Image is required'
          }
        }
      }
    }
  },
  validations: {
    form: {
      cdnImage: {
        required
      }
    }
  },
  components: {
    PImage,
    Treeselect
  },
  computed: {
    show: {
      get: function () {
        return this.showAddModal
      },
      set: function () {
        return this.showAddModal
      }
    },
    filterFolderList () {
      return this.folderList.filter(x => x.Id !== 0)
    }
  },
  watch: {
    activefolder: function (val) {
      if (this.fileSelectError) {
        this.fileSelectError = false
      }
    }
  },
  methods: {
    normalizer (node) {
      return {
        id: node.Id,
        label: node.Name,
        children: node.children
      }
    },
    setData () {
      if (this.parentIdx && this.parentIdx !== '') {
        this.activefolder = this.parentIdx
      }
    },
    async addImage () {
      try {
        if (!this.activefolder) {
          this.fileSelectError = true
          return
        }
        this.$v.form.$touch()
        if (this.$v.form.$error) {
          return true
        } else {
          let formData = new FormData()
          if (this.activefolder) {
            formData.append('folderId', parseInt(this.activefolder))
          }
          formData.append('Image', this.form.cdnImage)
          await this.$http.post(`${this.API_ENDPOINT}/fileManager/image/upload`, formData, { headers: { 'Content-Type': 'application/json' } })
          this.$emit('loadUpdatedData')
          this.cancelAddModal()
          Events.$emit('alert', VueNotifications.types.success, 'Success', 'Game Platform Image Updated Successfully.')
        }
      } catch (err) {
        console.log('this is an error ', err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      }
    },
    cancelAddModal () {
      this.form.cdnImage = ''
      this.$emit('cancelAddFolderModal')
      this.$v.form.$reset()
    }
  }
}
</script>

<style> 
  .uploadCdnImageWrapper img {
    max-width: 300px;
    width: 100%;
  }
  .uploadCdnImageWrapper .image-holder button {
    display: block
  }
  .uploadCdnImageWrapper .vue-treeselect__menu {
    min-height: 300px
  }
  .uploadImageErrorCDN {
    color: #f86c6b;
  }
</style>


// WEBPACK FOOTER //
// src/views/cdnFileManager/UploadImage.vue